import { DEFAULT_LIMIT } from '../SearchManager/FormData';

export interface IFormData {
  showNonEffective: boolean
  label: string | null
  offset: number
  limit: number
  currentPage: number
}

export class FormData implements IFormData {
  showNonEffective: boolean
  label: string | null
  offset: number
  limit: number
  currentPage: number

  constructor() {
    this.showNonEffective = false;
    this.label = null;
    this.offset = 0;
    this.limit = DEFAULT_LIMIT;
    this.currentPage = 1;
  }

}
